import 'yet-another-react-lightbox/styles.css'

import React, { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'

import { Attachment } from '@/types/Attachment'

type Props = {
  attachments: Attachment[]
}

export const HomeQualityCheckSummaryMedia = ({ attachments }: Props) => {
  const [filePath, setFilePath] = useState<string>()

  return (
    <div className="flex w-full flex-col">
      {attachments.map((file, i) => {
        return (
          <img
            alt={file.filename}
            aria-hidden="true"
            className="p-2 block m-auto max-h-48 mb-2 rounded-xl cursor-pointer"
            key={i}
            onClick={() => setFilePath(file.path)}
            src={`/${file.path}`}
          />
        )
      })}
      <div>
        <Lightbox
          close={() => setFilePath(undefined)}
          open={!!filePath}
          slides={filePath ? [{ src: `/${filePath}` }] : []}
        />
      </div>
    </div>
  )
}
